var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSingleNeutralMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.18 13.5a6.49 6.49 0 0 0-12.36 0h12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9A4.232 4.232 0 1 0 7 .536 4.232 4.232 0 0 0 7 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.382 6.405s-.351.691-1.382.691c-1.03 0-1.382-.69-1.382-.69m5.537-2.444h-.028a4.117 4.117 0 0 1-3.09-1.392 4.117 4.117 0 0 1-3.091 1.392 4.109 4.109 0 0 1-1.973-.5 4.234 4.234 0 0 1 8.182.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSingleNeutralMale);
export default __webpack_public_path__ + "static/media/User-Single-Neutral-Male.f7de1fea5b80d857e8227c131d7ae197.svg";
export { ForwardRef as ReactComponent };